import { useRouter } from 'next/router';

import styles from './WireHeader.module.scss';

export const WireHeader = () => {
  const router = useRouter();

  const { query } = router;
  const { orderby } = query;

  return (
    <div className={styles.block} data-sort-type={orderby || 'rating'}>
      <span data-name="player">Player</span>

      <span aria-label="Position" data-name="position">
        Pos
      </span>

      <span data-name="rating">Rating</span>
      <span data-name="nil">NIL Value</span>

      <span data-name="player-status">Status</span>
      <div data-name="team-status">
        <span>Last Team</span>
        <span>New Team</span>
      </div>
    </div>
  );
};
